import React, {useState, useEffect} from 'react'
import "../App.css"
import "../toggle.css"
import Organisation from './Organisation';

// import Multiselect from 'multiselect-react-dropdown';


const FilterBar = (props) =>  {
    
    const {
        selectedRegion,
        allData,
        targetAudience,
        ageGroups,
        activities
        // professions,
        // trades
    } = props;

    const [output, setOutput] = useState([])


    const [input, setInput] = useState({
        name: "",
        activities: "",
        ageGroups: "",
        targetAudience: "",
        // professions: "",
        // trades: "",
        region:"",
    })
    
    const handleChange = (e) => {
        const {name, value} = e.target;
        setInput((prev) => {
            return {...prev, [name]: value}
        })
    };



    const organisationCount = output.length

    const handleAddOrganisationLink = () => {

        window.open("https://www.buildingpeople.org.uk/Home/Sign-In/id1/1");
    
    }

    const handleContactEmail = () => {

        window.open("mailto:hello@buildingpeople.org.uk");
    
    }

    const handleContactDetails = () => {

        window.open("https://docs.google.com/spreadsheets/d/1mf2TuWuo1zInAVjo1iYA6lineIHB4v0_/edit#gid=1338818178");
    
    }

    // const handleFilter = (selectedList, selectedItem) => {

    //     console.log(selectedList)

    //     const name = selectedItem.name
    //     const value = selectedItem.id

    //     setInput((prev) => {
    //         return {...prev, [value]: name}

            
    //     })
    //     console.log(input)

    // };

    // const clearFilter = (selectedList, selectedItem) => {

    //     const name = selectedItem.name
    //     const value = selectedItem.id

    //     setInput(prev => prev.filter(obj => {
    //             return obj.value !== name;
    //         }),
    //     );
    // };



    useEffect(() => {
        setOutput([])
        allData.filter(val=>{
            if(
                (val.properties["Organisation Name"].toLowerCase().includes(input.name.toLowerCase()) || 
                val.properties["Descriptor"].toLowerCase().includes(input.name.toLowerCase())|| 
                val.properties["Key words"].toLowerCase().includes(input.name.toLowerCase()))
                &&
                val.properties["Activities"].some(activity => activity.includes(input.activities))
                &&
                val.properties["Age groups"].some(ageGroup => ageGroup.includes(input.ageGroups))
                &&
                val.properties["Target group"].some(community => community.includes(input.targetAudience))
                &&
                // val.properties["Professions"].some(profession => profession.includes(input.professions))
                // &&
                // val.properties["Trades"].some(trade => trade.includes(input.trades))
                // &&
                val.properties["Regions"].some(region => region.includes(selectedRegion))
                &&
                val.properties.Website[1]
                )
                {setOutput(data=>[...data,val])}
                return allData
        })

    }, [allData, input, selectedRegion]);



    const closeFilter = () => {

        const filterDiv = document.getElementById('filter-sidebar');
 
        if (filterDiv.style.display !== "none") {
            filterDiv.style.display = "none";
          } else {
            filterDiv.style.display = "block";
          }
         
    }

    const openFilter = () => {

        const filterDiv = document.getElementById('filter-sidebar');

        if (filterDiv.style.display !== "none") {
            filterDiv.style.display = "none";
          } else {
            filterDiv.style.display = "block";
          }

    }

    return (

        <>

        <div id="filter-sidebar" className="filter-sidebar">

            <div className="info" data-msg="This interactive map from Barbour ABI and Building People helps users find organisations that provide built environment careers support to diverse and under-represented groups in the UK.">
                <svg width="100%" height="100%" fill="none" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 1 0 0-20z"></path>
                    <path d="M12 16v-4"></path>
                    <path d="M12 8h.01"></path>
                </svg>
            </div>

            <div className="logo">

                <a href="https://www.buildingpeople.org.uk/" target='_blank' rel="noreferrer">
                    <img 
                        id="buildingpeople-logo"     
                        src="Assets/BuildingPeople.png"
                        alt="">
                    </img>
                </a>

            </div>

            <div className='filter-title'>  

                <p> Use the filters below to find organisations that help people from diverse and under-represented backgrounds succeed in built environment careers. </p>

            </div>

            {/* <div className="userSwitch">

                <p> I am a: </p>

                <input id="toggle-on" class="toggle toggle-left" name="toggle" value="false" type="radio" checked />
                <label for="toggle-on" class="btn">Individual</label>
                <input id="toggle-off" class="toggle toggle-right" name="toggle" value="true" type="radio" />
                <label for="toggle-off" class="btn">Organisation</label>
                
            </div> */}





            <div className="filter-item"> 
                <p> {(selectedRegion === "") ? "Click a region on the map" : "Region : "} <b> {selectedRegion} </b> </p> 
            </div>


            <hr/>

            {/* <div className="filter-item">
                <label htmlFor="Multi Test">Activities</label>
                <Multiselect
                showCheckbox
                showArrow
                placeholder="Select Activity"
                options=  { activities.map(activity => (
                            {name: activity,
                            id: "activities"}))
                } 
                selectedValues= "" 
                onSelect= {handleFilter} 
                onRemove= {clearFilter}  
                displayValue="name" 
                style={{
                    chips: {
                      background: '#fdb913',
                      color: '#878E88'
                    }}}
                />
            </div>

            <div className="filter-item">
                <label htmlFor="Multi Test">Age Groups</label>
                <Multiselect
                showCheckbox
                showArrow
                placeholder="Select Age Groups"
                options=  { ageGroups.map(activity => (
                            {name: activity,
                            id: "ageGroups"}))
                } 
                selectedValues= "" 
                onSelect= {handleFilter} 
                onRemove= {clearFilter}  
                displayValue="name" 
                style={{
                    chips: {
                      background: '#fdb913',
                      color: '#878E88'
                    }}}
                />
            </div> */}

            <div className="filter-item">
                <label htmlFor="activities">Activities</label>
                <select 
                onChange={handleChange} name="activities"
                className="filter-content" id="activities">
                    <option value="">Choose an activity</option>
                    {activities.map((activities) => (
                        <option value={activities} key={activities}> {activities} </option> 
                         ))}
                </select>
            </div>

            <div className="filter-item">
                <label htmlFor="ageGroups">Age groups</label>
                <select 
                onChange={handleChange} name="ageGroups"
                className="filter-content" id="ageGroups">
                    <option value="">Choose an age group</option>
                    {ageGroups.map((ageGroup) => (
                        <option value={ageGroup} key={ageGroup}> {ageGroup} </option> 
                         ))}
                </select>
            </div>

            <div className="filter-item"> 
                <label htmlFor="targetAudience">Target group</label>
                <select 
                onChange={handleChange} name="targetAudience"
                className="filter-content" id="targetAudience">
                    <option value="">Choose a target group</option>
                    {targetAudience.map((targetAudience) => (
                        <option value={targetAudience} key={targetAudience}> {targetAudience} </option> ))}
                </select>
            </div>

            {/* <div className="filter-item">
                <label htmlFor="professions">Professions</label>
                <select 
                onChange={handleChange} name="professions"
                className="filter-content" id="professions">
                    <option value="">Choose a Profession</option>
                    {professions.map((profession) => (
                        <option value={profession} key={profession}> {profession} </option> ))}
                </select>
            </div> */}

            {/* <div className="filter-item">
                <label htmlFor="trades">Trades</label>
                <select 
                onChange={handleChange} name = "trades"
                className="filter-content" id="trades">
                    <option value="">Choose a Trade</option>
                    {trades.map((trade) => (
                        <option value={trade} key={trade}> {trade} </option> ))}
                </select>
            </div> */}

            <div className="filter-item">
                    <label htmlFor="companyName">Search by keyword</label>
                    <input 
                        name="name" placeholder='Search here...'
                        onChange={handleChange} type="text"
                        className="filter-content" id="companyName" />
            </div>

            <button id="filterClose-button" className="filterClose-button" onClick={closeFilter}> Search Organisations </button>

            <div className="logo">
                <a href="https://www.barbour-abi.com" target='_blank' rel="noreferrer">
                    <img 
                        id="barbour-logo"     
                        src="Assets/Barbour_ABI_Partner_Logo.png"
                        alt="">
                    </img>
                </a>


            </div>

        </div>
        
        <div className="organisation-header" >

            <div className="contact-buttons"> 
                <div className="inner-button"> <button  onClick={handleContactEmail}> Contact us </button> </div>
                <div className="inner-button"> <button  onClick={handleAddOrganisationLink}> Add your organisation</button> </div>
                <div className="inner-button" onClick={handleContactDetails} data-msg="Log in to view organisation contact details">
                    <svg width="40" height="40" fill="none" stroke="#212529" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                        <path d="m10 17 5-5-5-5"></path>
                        <path d="M15 12H3"></path>
                    </svg>
                </div>
            </div>


            <h2> Search results </h2>

            <h3> {organisationCount}  {(organisationCount === 1) ? "Organisation" : "Organisations"} </h3>

            <div className="organisation-list" >          

                {
                output.map(organisation => 
                    <Organisation key={organisation.properties.id} organisation={organisation}/>
                )
                }

            </div> 

        </div>        

        <div id="open-filter" className="open-filter" >
                <svg onClick={openFilter} width="46" height="46" fill="#fdb913" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"></path>
                </svg>
        </div>


    </>                    
            
    );
    };

export default FilterBar ;



